import React from "react";
import { HandCircle } from "../brand/Doodles";

const STATS = [
  { display: "14", label: "Live Products", body: "Ideas that made it out of the notebook and into the real world." },
  { display: "30+", label: "Years in Tech + Marketing", body: "Technology changes. Understanding people and business still matters." },
  { display: "Days", label: "Not Months to Ship", body: "AI changes what's possible when you know how to put it to work.", circled: true },
];

export const Proof = () => {
  return (
    <section
      id="proof"
      data-testid="proof-section"
      className="relative"
      style={{ paddingTop: "clamp(64px, 10vh, 140px)", paddingBottom: "clamp(64px, 10vh, 140px)" }}
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <h2
          className="font-condensed font-bold text-white uppercase max-w-3xl"
          style={{ fontSize: "clamp(2rem, 4.5vw, 3.25rem)", lineHeight: 1.05, letterSpacing: "-0.02em" }}
          data-testid="proof-headline"
        >
          Don't Take My Word for It.
        </h2>

        <ol className="mt-14 grid gap-10 md:gap-0 md:grid-cols-3" data-testid="proof-stats">
          {STATS.map((s, i) => (
            <li
              key={s.label}
              data-testid={`proof-stat-${i}`}
              className={`md:px-8 md:first:pl-0 ${i ? "md:border-l md:border-dashed md:border-white/20" : ""} ${i === 1 ? "md:mt-6" : ""}`}
            >
              <div className="relative inline-block font-condensed font-bold text-white" style={{ fontSize: "clamp(3.25rem, 6vw, 5rem)", lineHeight: 1, letterSpacing: "-0.03em" }}>
                {s.display}
                {s.circled && <HandCircle className="absolute -left-2 -right-2 -top-3 -bottom-3 md:-left-6 md:-right-6 md:-top-4 md:-bottom-4 w-[calc(100%+16px)] h-[calc(100%+24px)] md:w-[calc(100%+48px)] md:h-[calc(100%+32px)]" />}
              </div>
              <div className="mt-5 ggm-hand text-lg">{s.label}</div>
              <p className="mt-3 font-body text-white/70 text-sm md:text-base leading-relaxed max-w-xs">{s.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Proof;
